module.exports = function (Vue, config) {
  Vue.mixin({
    created: function () {
      this.$config = config
    }
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-config/index.js
// module id = 232
// module chunks = 1